import { useCallback } from 'react';
import styles from './productGroupTips.module.scss';
import { defaultTo } from 'lodash';

type ProductGroupTipsProps = {
  productGroup: SelectOptions;
  showId: boolean;
};

export const ProductGroupTips: React.FC<ProductGroupTipsProps> = ({
  productGroup,
  showId
}) => {
  const renderTips = useCallback(() => {
    const formatter = (value: string) => {
      if (value.startsWith('asiamax\\')) {
        return value;
      }
      return value.replace(/\\/, '');
    };
    return defaultTo(productGroup.extra, []).map((group) => (
      <li key={group.value}>
        <div>{group.label}</div>
        {showId && <div>{`ID: ${formatter(group.value.toString())}`}</div>}
      </li>
    ));
  }, [productGroup, showId]);

  return (
    <div className={styles.productGroupTips}>
      <ul>{renderTips()}</ul>
    </div>
  );
};

export const renderProductGroupTips = (
  productGroup: SelectOptions,
  showId: boolean
) => {
  return <ProductGroupTips productGroup={productGroup} showId={showId} />;
};
